import { render, staticRenderFns } from "./Multipletable.vue?vue&type=template&id=b16c4d1e"
import script from "./Multipletable.vue?vue&type=script&lang=js"
export * from "./Multipletable.vue?vue&type=script&lang=js"
import style0 from "./Multipletable.vue?vue&type=style&index=0&id=b16c4d1e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b16c4d1e')) {
      api.createRecord('b16c4d1e', component.options)
    } else {
      api.reload('b16c4d1e', component.options)
    }
    module.hot.accept("./Multipletable.vue?vue&type=template&id=b16c4d1e", function () {
      api.rerender('b16c4d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/Multipletable.vue"
export default component.exports